module.exports = __webpack_public_path__ + "media/theme/icon__footer--social-d17c2121.svg";